import { Injectable } from "@angular/core";
import { ClaimColumnName } from "@helper/types/claim";

@Injectable()
export class ClaimsColumnsService {
	private key = "dom.claims.columns";

	public save(columns: ClaimColumnName[]): void {
		localStorage.setItem(this.key, columns.join("."));
	}

	public restore(): ClaimColumnName[] {
		const str = localStorage.getItem(this.key) || null;
		return (str ? str.split(".") : [
			"id",
			"payerNumber",
			"invoiceDate",
			"dueDate",
			"fullName",
			"description",
			"sum",
			"paymentSum"
		]) as ClaimColumnName[];
	}
}
